import React from "react";
import { useIntl } from "react-intl";
import { expectedDayCountFor, familyOf, } from "../../types/schedule";
import { AnchorDatesEditor } from "./AnchorDatesEditor";
import { BimonthlyEditor } from "./BimonthlyEditor";
import { BiweeklyEditor } from "./BiweeklyEditor";
import { DaysOfMonthEditor } from "./DaysOfMonthEditor";
import { WeekdayMaskEditor } from "./WeekdayMaskEditor";
import { WeekdaySingleEditor } from "./WeekdaySingleEditor";
export var ScheduleEditor = function (_a) {
    var frequency = _a.frequency, value = _a.value, onChange = _a.onChange, disabled = _a.disabled;
    var formatMessage = useIntl().formatMessage;
    var family = familyOf(frequency);
    var count = expectedDayCountFor(frequency);
    switch (family) {
        case "WEEKDAY_MASK":
            return (React.createElement(WeekdayMaskEditor, { value: value, onChange: onChange, disabled: disabled }));
        case "WEEKDAY_SINGLE":
            return (React.createElement(WeekdaySingleEditor, { value: value, onChange: onChange, disabled: disabled }));
        case "BIWEEKLY":
            return (React.createElement(BiweeklyEditor, { value: value, onChange: onChange, disabled: disabled }));
        case "DAYS_OF_MONTH":
            return (React.createElement(DaysOfMonthEditor, { value: value, onChange: onChange, count: count, disabled: disabled }));
        case "BIMONTHLY":
            return (React.createElement(BimonthlyEditor, { value: value, onChange: onChange, disabled: disabled }));
        case "ANCHOR_DATES":
            return (React.createElement(AnchorDatesEditor, { value: value, onChange: onChange, count: count, disabled: disabled }));
        default:
            return (React.createElement("p", null, formatMessage({ id: "ui-br-legaldeposits.schedule.manual.info" })));
    }
};
